<template>
  <div class="vx-col w-5/6 ml-auto mr-auto" v-if="isQueryDone">
    <span>
      <h4 class="mb-5">Vendor Invoice</h4>
    </span>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Vendor"
          name="Vendor"
          :value="supplier"
          readonly
        />
      </div>
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="PO Code"
          name="PO Code"
          :value="poCode"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Number"
          name="Invoice Number"
          :value="invoiceNumber"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Currency Code"
          name="Currency Code"
          :value="currencyCode"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Due Date"
          name="Due Date"
          :value="dateFormat(this.propose.DueDate)"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Payment Term"
          name="Payment Term"
          :value="paymentTerm"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Bank Name"
          name="Bank Name"
          :value="bankName"
          readonly
        />
      </div>
    </div>
    <vs-divider style="width: 100%"><b>Notes</b></vs-divider>

    <b v-for="(note, idx) in notesLine" :key="`note-${idx}`"
      >{{ note }}
      <br />
    </b>
    <br />
    <vs-divider style="width: 100%; margin-left: 2%"><b>Comment</b></vs-divider>
    {{ comment }}
    <vs-divider style="width: 100%"><b>Attachment</b></vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <div class="vx-col sm:w-1/3 w-full">
        <span>File</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <input
            id="fileInput"
            name="file"
            class="w-full inputx"
            type="file"
            ref="file"
            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"
          />
        </div>
      </div>
    </div>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%">
      <div class="vx-col sm:w-1/3 w-full">
        <span></span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-button class="mr-3 mb-2" @click="handleAttachment"
            >Add Attachment</vs-button
          >
        </div>
      </div>
    </div>
    <vs-divider style="width: 100%"><b>List Attachment</b></vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%">
      <table class="vs-table vs-table--tbody-table">
        <!-- attachment -->
        <template v-for="tr in attachment">
          <tr
            class="tr-values vs-table--tr tr-table-state-null selected"
            v-bind:key="tr.PathFile"
          >
            <td class="td vs-table--td">{{ tr.NameFile }}</td>
            <td class="td vs-table--td">
              <div class="flex gap-4">
                <vx-tooltip text="Show" v-if="tr.PathFile != ''">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="downloadFileAwsS3(tr.PathFile)"
                    icon="icon-eye"
                  />
                </vx-tooltip>
                <vx-tooltip text="Delete" v-if="tr.PathFile != ''">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="handleShowDeletePrompt(tr)"
                    icon="icon-trash"
                    color="danger"
                  />
                </vx-tooltip>
              </div>
            </td>
            <!-- <td class="td vs-table--td">
                <template>
                  <vx-tooltip text="Delete">
                    <vs-button
                      type="line"
                      icon-pack="feather"
                      @click.stop="handleDeleteAttachment(i, tr.ID)"
                      icon="icon-trash"
                    />
                  </vx-tooltip>
                </template>
              </td> -->
          </tr>
        </template>
      </table>
    </div>

    <vs-divider style="width: 100%"></vs-divider>
    <span>
      <h4 class="mb-5">Line Item</h4>
    </span>
    <div class="vx-row mb-2">
      <table class="table">
        <thead style="font-weight: bold">
          <tr>
            <td>Item</td>
            <td>Qty Inv</td>
            <td>Total Price</td>
            <td>Discount</td>
            <td>Net</td>
            <td>Tax</td>
            <td>Wh Tax</td>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in lineItem">
            <tr v-bind:key="item.ID">
              <td>{{ item.ItemName }}</td>
              <td>{{ item.Quantity }} {{ item.ItemUnit }}</td>
              <td>{{ priceFormat(item.Price) }}</td>
              <td>{{ priceFormat(item.Discount) }}</td>
              <td>{{ priceFormat(item.Subtotal) }}</td>
              <td>{{ priceFormat(item.Tax) }} ({{ item.TaxRate }}%)</td>
              <td>{{ priceFormat(item.WhTax) }} ({{ item.WhTaxRate }}%)</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Payment Bank</b></vs-divider
    >
    <div>
      Paid Value : {{ total_paid }}<br />
      <template v-if="total_unpaid.toString().replace(/,/g, '') >= 0">
        Unpaid Value : {{ total_unpaid }}<br />
      </template>
      <template v-else>
        Unpaid Value : 0<br />
        Overpayment :
        {{
          (total_unpaid.toString().replace(/,/g, "") * -1)
            .toString()
            .replace(/,/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }}<br />
      </template>
    </div>
    <vs-table stripe border description :sst="true" :data="payments">
      <template slot="thead">
        <vs-th>Payment Code</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Bank Name</vs-th>
        <vs-th>Account Number</vs-th>
        <vs-th>Payment Voucher</vs-th>
        <vs-th>Total Paid</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.payment_code }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.type }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.bank_name }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.account_number }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.reference_code }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ priceFormat(tr.total_paid) }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%"></vs-divider>
    <span>
      <h4 class="mb-5">Charges</h4>
    </span>
    <div class="vx-row mb-2">
      <table class="table">
        <thead style="font-weight: bold">
          <tr>
            <td>Charge Name</td>
            <td>Value</td>
            <td>Tax</td>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in charge">
            <tr v-bind:key="item.ID">
              <td>{{ item.ChargeName }}</td>
              <td>{{ priceFormat(item.Amount) }}</td>
              <td>{{ priceFormat(item.TaxAmount) }} ({{ item.TaxRate }}%)</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Proposal Payment History </b></vs-divider
    >
    <vs-table stripe border description :sst="true" :data="dataPaymentProposal">
      <template slot="thead">
        <vs-th>Code</vs-th>
        <vs-th>Plan Date Payment</vs-th>
        <vs-th>Paid</vs-th>
        <vs-th>Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            {{ tr.Code }}
          </vs-td>
          <vs-td>
            {{ dateFormat(tr.PurposePaymentDate) }}
          </vs-td>
          <vs-td>
            {{ tr.PaidValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </vs-td>
          <vs-td>
            <template v-if="tr.Status == 0"> Waiting </template>
            <template v-else-if="tr.Status == 1">
              Approved, Waiting Execute
            </template>
            <template v-else-if="tr.Status == 2"> Rejected </template>
            <template v-else-if="tr.Status == 3"> Done </template>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%"></vs-divider>
    <span>
      <h4 class="mb-5">Propose Payment</h4>
    </span>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Payment Value"
          name="Payment Value"
          :value="priceFormat(propose.PaidValue)"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <vs-alert
        color="warning"
        class="mt-3"
        icon-pack="feather"
        close-icon="icon-x"
      >
        Propose Payment of <b>{{ priceFormat(propose.PaidValue) }}</b> for
        <b>{{ purchase.Code }}</b> has been approved
      </vs-alert>
    </div>
    <vs-divider style="width: 100%"><b>No Vendor Invoice</b></vs-divider>
    <vs-input v-model="selected.VendorInvoiceNumber" class="w-full" />
    <vs-divider style="width: 100%"><b>Description</b></vs-divider>
    <vs-input v-model="description" class="w-full" />
    <div class="flex mt-6 justify-end w-full" style="width: 100%">
      <vs-button @click="updateInformation">Save</vs-button>
    </div>
    <!-- confirmation modal -->
    <vs-prompt
      title="Confirmation"
      color="primary"
      @accept="doSubmit"
      @cancel="closeConfirmation"
      @close="closeConfirmation"
      :buttons-hidden="false"
      :active.sync="confirmation"
    >
      <div class="con-exemple-prompt">
        Proposal Payment Need Approval Propose Payment of
        <b>{{ priceFormat(propose.PaidValue) }}</b> for
        <b>{{ purchase.Code }}</b>
        <br />
        Are you sure to
        <b>{{ approveOrReject ? "Approve" : "Reject" }}</b> Propose Payment ?
        <br />
        <br />
        <vs-textarea v-model="notes" placeholder="Note" />
      </div>
    </vs-prompt>
    <vs-prompt
      title="Confirmation"
      color="danger"
      @accept="handleDeleteAttachment"
      @cancel="handleCloseDeletePrompt"
      @close="handleCloseDeletePrompt"
      :accept-text="'Yes'"
      :cancel-text="'No'"
      :active.sync="isShowDeletePrompt"
    >
      <div class="font-bold">Are you sure to delete this attachment ?</div>
    </vs-prompt>
    <!-- <div class="vx-row mb-2">
       <div class="vx-col" style="margin-bottom: 150px; margin-top: 50px">
          <vs-button
            v-on:click="doApprove"   
            color="primary"
            icon-pack="feather"
            icon="icon-inbox"
            >Approve</vs-button
          >
        </div>
        <div class="vx-col" style="margin-bottom: 150px; margin-top: 50px">
          <vs-button
            v-on:click="doReject"   
            color="warning"
            icon-pack="feather"
            icon="icon-x"
            >Reject</vs-button
          >
        </div>
    </div> -->
    <!-- <vs-divider style="width: 100%;"></vs-divider>
    <span>
      <h4 class="mb-5">Line Item</h4>
    </span>
    <div class="vx-row mb-2">
    </div> -->
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    selected: Object,
  },
  mounted() {
    console.log(this.selected.id, "data");
    this.getData();
  },
  data() {
    return {
      purchase: {},
      cnSupplier: {},
      advanceInvoice: {},
      lineItem: [],
      charge: [],
      attachment: [],
      dataPaymentProposal: [],
      propose: {},
      notes: "",
      comment: "",
      description: "",
      confirmation: false,
      approveOrReject: 0,
      file: null,
      payments: [],
      total_paid: "",
      total_unpaid: "",
      isQueryDone: false,
      isShowDeletePrompt: false,
      attachmentID: null,
      notesLine: [],
      advanceInvoiceLines: [],
    };
  },
  computed: {
    supplier() {
      // return this.purchase.SupplierCode + " " + this.purchase.SupplierName;
      if (this.propose.PurchaseInvoiceID) {
        return this.purchase.SupplierCode + " " + this.purchase.SupplierName;
      } else if (this.propose.CnSupplierID) {
        return (
          this.cnSupplier.SupplierCode + " " + this.cnSupplier.SupplierName
        );
      } else {
        return (
          this.advanceInvoice.partner_code +
          " " +
          this.advanceInvoice.partner_name
        );
      }
    },
    invoiceNumber() {
      if (this.propose.PurchaseInvoiceID) {
        return this.purchase.Code;
      } else if (this.propose.CnSupplierID) {
        return this.cnSupplier.Code;
      } else {
        return this.advanceInvoice.external_code;
      }
    },
    currencyCode() {
      if (this.propose.PurchaseInvoiceID) {
        return this.purchase.CurrencyCode;
      } else if (this.propose.CnSupplierID) {
        return "IDR";
      } else {
        return "IDR";
      }
    },
    paymentTerm() {
      if (this.propose.PurchaseInvoiceID) {
        return this.purchase.PaymentTermName;
      } else if (this.propose.CnSupplierID) {
        return "";
      } else {
        return this.advanceInvoice.payment_term_name;
      }
    },
    bankName() {
      if (this.propose.PurchaseInvoiceID) {
        return `${this.purchase.BankName} - ${this.purchase.AccountNumber} ${this.purchase.AccountName}`;
      } else if (this.propose.CnSupplierID) {
        return "";
      } else {
        return `${this.advanceInvoice.partner_bank_name} - ${this.advanceInvoice.partner_bank_account_number} ${this.advanceInvoice.partner_bank_account_name}`;
      }
    },
    poCode() {
      if (this.propose.PurchaseInvoiceID) {
        return this.purchase.ReferencePurchaseCode;
      } else {
        return this.advanceInvoiceLines[0].document_code;
      }
    },
  },
  watch: {
    "selected.ID"() {
      this.getData();
    },
  },
  methods: {
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("YYYY-MM-DD");
      }
    },
    handleShowAttachment(selected) {
      console.log(selected);
      if (selected.path != "" && selected.path !== undefined) {
        window.open(selected.path);
      } else if (selected.PathFile != "" && selected.PathFile !== undefined) {
        window.open(selected.PathFile);
      }
    },
    handleShowDeletePrompt(tr) {
      if (tr && tr.ID) {
        this.attachmentID = tr.ID;
      } else if (tr && tr.ListID) {
        this.attachmentID = tr.ListID;
      } else {
        this.attachmentID = null;
        this.$vs.notify({
          color: "danger",
          title: "error",
          text: "No valid attachment found for delete.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }
      this.isShowDeletePrompt = true;
    },
    handleCloseDeletePrompt() {
      this.isShowDeletePrompt = false;
      this.attachmentID = null;
    },
    handleDeleteAttachment() {
      this.deleteFile(this.attachmentID);
      // console.log(this.table.file);
    },
    deleteAttachmentAdvanceInvoice(id) {
      this.$vs.loading();
      var form = new FormData();
      form.append("list_id", id);
      form.append("id", this.advanceInvoice.ID);
      this.$http
        .post("/api/v1/advance-invoice/delete-file", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            //remove item with related id from attachment
            this.attachment = this.attachment.filter(
              (item) => item.ListID !== id
            );
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    deleteAttachmentPurchaseInvoice(id) {
      this.$vs.loading();
      var form = new FormData();
      form.append("id", id);
      this.$http
        .post("/api/v1/pi/delete-file", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            //remove item with related id from attachment
            this.attachment = this.attachment.filter((item) => item.ID !== id);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    deleteFile(id) {
      if (this.propose.AdvanceInvoiceID) {
        this.deleteAttachmentAdvanceInvoice(id);
      } else if (this.propose.PurchaseInvoiceID) {
        this.deleteAttachmentPurchaseInvoice(id);
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Warning",
          text: "No valid type found for delete.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    doApprove() {
      this.approveOrReject = 1;
      this.notes = "";
      this.confirmation = true;
    },
    doReject() {
      this.approveOrReject = 0;
      this.notes = "";
      this.confirmation = true;
    },
    closeConfirmation() {
      this.confirmation = false;
    },
    doSubmit() {
      this.$vs.loading();
      const params = {
        status: this.approveOrReject,
        propose_id: this.propose.ID,
        purchase_invoice_id: this.propose.PurchaseInvoiceID,
      };

      this.$http
        .post("/api/v1/purchase-payment-proposal/change-status", params)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "error catch",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log(e);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    handleAttachment() {
      console.log(this.$refs.file.files[0]);
      if (this.$refs.file.files[0]) {
        // this.table.file.push({
        //   name: this.$refs.file.files[0].name,
        //   file: this.$refs.file.files[0],
        //   isNew: true,
        //   path: "",
        // });
        this.file = this.$refs.file.files[0];
        document.querySelector("#fileInput").value = "";
        this.uploadData();
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please select file to import.",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    paramUpload() {
      var form = new FormData();
      if (this.propose.AdvanceInvoiceID) {
        form.append("id", this.propose.AdvanceInvoiceID);
      } else if (this.propose.PurchaseInvoiceID) {
        form.append("pi_id", this.propose.PurchaseInvoiceID);
      } else {
        this.$vs.notify({
          title: "Error",
          text: "No valid type found for upload.",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return null;
      }

      form.append("file", this.file);
      return form;
    },
    uploadAttachmentAdvanceInvoice() {
      this.$vs.loading();
      this.$http
        .post("/api/v1/advance-invoice/upload-file", this.paramUpload(), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.reloadAttachmentWithRetry();
            
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    // Method to handle database replica delay
    reloadAttachmentWithRetry(maxRetries = 6) {
      let attempts = 0;
      const initialCount = this.attachment.length;
      
      const attemptReload = () => {
        attempts++;
        console.log(`Sync attempt ${attempts}/${maxRetries}`);
        
        // Check if attachment list updated after data reload
        this.$nextTick(() => {
          setTimeout(() => {
            console.log(`Attachment initial count: ${initialCount}`);
            console.log(`Attachment after reload count: ${this.attachment.length}`);
            if (this.attachment.length > initialCount) {
              this.$vs.loading.close();
              console.log('Sync attachment successful, attachment list updated');
            } else if (attempts < maxRetries) {
              console.log('Retrying...');
              setTimeout(attemptReload, 500 * attempts); // Exponential backoff

              // Get fresh data from database
              this.getDataForAttachment();
            } else {
              this.$vs.loading.close();
              console.log('Max retries reached, attachment may appear with page refresh');
              this.$vs.notify({
                color: "warning",
                title: "Database Sync",
                text: "Attachment uploaded but may need page refresh to appear",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-alert-circle",
              });
            }
          }, 200); // Wait for DOM update
        });
      };
      
      // Start with small delay for initial database sync
      setTimeout(attemptReload, 300);
    },
    uploadAttachmentPurchaseInvoice() {
      this.$vs.loading();
      this.$http
        .post("/api/v1/pi/upload-file", this.paramUpload(), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.attachment.push({
            ID: resp.data.attachment.ID,
            NameFile: resp.data.attachment.NameFile,
            PathFile: resp.data.attachment.PathFile,
          });
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    uploadData() {
      if (this.propose.AdvanceInvoiceID) {
        this.uploadAttachmentAdvanceInvoice();
      } else if (this.propose.PurchaseInvoiceID) {
        this.uploadAttachmentPurchaseInvoice();
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Warning",
          text: "No valid type found for upload.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/purchase-payment-proposal/line/" + this.selected.ID)
        .then((r) => {
          this.$vs.loading.close();
          if (r.code <= 299) {
            this.propose = r.data.purchasePaymentProposal;
            this.dataPaymentProposal.push(r.data.purchasePaymentProposal);
            if (this.propose && this.propose.PurchaseInvoiceID) {
              this.purchase = r.data.purchaseInvoice;
              this.lineItem = r.data.linePurchaseInvoice;
              this.charge = r.data.charge;
              this.attachment = r.data.attachment;
              this.comment = this.purchase.CommentInvoice;
              this.payments = r.data.data_payment;
              this.description = this.purchase.Description;
              this.notesLine = this.purchase.Notes.split(";");
            } else if (this.propose && this.propose.CnSupplierID) {
              // this.comment = this.purchase.Comment;
              this.cnSupplier = r.data.creditNoteSupplier;
              this.payments = r.data.payments;
              this.attachment = r.data.creditNoteSupplierAttachment
                ? r.data.creditNoteSupplierAttachment
                : [];
              this.description = r.data.description;
            } else if (this.propose && this.propose.AdvanceInvoiceID) {
              this.advanceInvoice = r.data.advanceInvoice;
              this.payments = r.data.payments;
              this.description = this.advanceInvoice.description;
              this.attachment = r.data.advanceInvoice.attachment
                ? r.data.advanceInvoice.attachment
                : [];
              this.notesLine = this.advanceInvoice.notes.split(";");
              this.advanceInvoiceLines = r.data.advanceInvoiceLine;
            }

            this.total_paid = this.priceFormat(r.data.paid);
            this.total_unpaid = this.priceFormat(r.data.unpaid_value);

            this.isQueryDone = true;
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          console.log(e);
        });
    },
    getDataForAttachment() {
      this.$http
        .get("/api/v1/purchase-payment-proposal/line/" + this.selected.ID)
        .then((r) => {
          if (r.code <= 299) {
            if (this.propose && this.propose.PurchaseInvoiceID) {
              this.attachment = r.data.attachment;
            } else if (this.propose && this.propose.CnSupplierID) {
              this.attachment = r.data.creditNoteSupplierAttachment
                ? r.data.creditNoteSupplierAttachment
                : [];
            } else if (this.propose && this.propose.AdvanceInvoiceID) {
              this.attachment = r.data.advanceInvoice.attachment
                ? r.data.advanceInvoice.attachment
                : [];
            }
            this.isQueryDone = true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateInformation() {
      if (
        (!this.selected.VendorInvoiceNumber ||
          this.selected.VendorInvoiceNumber == "") &&
        (!this.description || this.description == "")
      ) {
        this.$vs.loading.close();
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "No Vendor Invoice or Description cannot be empty",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }

      // if (this.selected.Description == "") {
      //   this.$vs.loading.close();
      //   this.$vs.notify({
      //     color: "danger",
      //     title: "Error",
      //     text: "Description cannot be empty",
      //     position: "top-right",
      //     iconPack: "feather",
      //     icon: "icon-x-circle",
      //   });
      //   return;
      // }
      this.$vs.loading();
      const body = {
        id: this.selected.ID,
        vendor_invoice_number: this.selected.VendorInvoiceNumber,
        description: this.description,
      };

      if (this.propose.PurchaseInvoiceID) {
        body.purchase_invoice_id = this.propose.PurchaseInvoiceID;
      } else if (this.propose.CnSupplierID) {
        body.cn_supplier_id = this.propose.CnSupplierID;
      } else if (this.propose.AdvanceInvoiceID) {
        body.advance_invoice_id = this.propose.AdvanceInvoiceID;
      }

      this.$http
        .put("/api/v1/purchase-payment-proposal/information", body)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.getData();
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "error catch",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log(e);
        });
    },
  },
};
</script>
<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
</style>
